import myntra from '../images/myntra.png';
import offer from '../images/offer.png';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import './navbar.css'
import { useDispatch, useSelector } from 'react-redux';
import { changeTheme } from '../Redux/Slices/Theme';
library.add(fas);
 const Navbar = () => {
  const theme = useSelector((state)=>state.theme);
  const style=theme==="light"?{color:"black"}:{color:"white"};
  //theme based styling for dropdown
  const styleDropdown = theme === " light"?{backgroundColor:"#f9f9f9"}:{backgroundColor:"#8C8C8C"};
   const dispatch = useDispatch();
  return (
    <>
    <header style={{ position: 'sticky', top: '0' }}>
        <nav >
          <div className="nav_bar" style={theme==="light"?{backgroundColor:"white"}:{backgroundColor:"#44444C"}}>
            <div className="nav_bar_items" >
              <a href="">
                <img src={myntra} alt="myntra logo" style={{ height: '50px' }} />
              </a>
            </div>
            <div className="nav_bar_items drp" >
              <Link to="/productListing" style={style}>MEN</Link>
    <div class="dropdown"  style={styleDropdown}>
        
         <div class="drop-content" >
            <ul>
                <li><h4>Topwear</h4></li>
                <li><a href="#">T-Shirts</a></li>
                <li><a href="#">Casual Shirts</a></li>
                <li><a href="#">Formal Shirts</a></li>
                <li><a href="#">Sweatshirts</a></li>
                <li><a href="#">Sweaters</a></li>
                <li><a href="#">Jackets</a></li>
                <li><a href="#">Blazers & Coats</a></li>
                <li><a href="#">Suits</a></li>
                <li><a href="#">Rain Jackets</a></li>
            </ul>
            <hr/>
            <ul>
                <li><h4>Indian & Festive Wear</h4></li>
                <li><a href="#">Kurtas & Kurta Sets</a></li>
                <li><a href="#">Sherwanis</a></li>
                <li><a href="#">Nehru Jackets</a></li>
                <li><a href="#">Dhotis</a></li>
            </ul>
            
        </div>
        
        <div class="drop-content">
            <ul>
                <li><h4>Bottomwear</h4></li>
                <li><a href="#">Jeans</a></li>
                <li><a href="#">Casual Trousers</a></li>
                <li><a href="#">Formal Trousers</a></li>
                <li><a href="#">Shorts</a></li>
                <li><a href="#">Track Pants & Joggers</a></li>
            </ul>
            <hr/>
            <ul>
                <li><h4>Innerwear & Sleepwear</h4></li>
                <li><a href="#">Briefs & Trunks</a></li>
                <li><a href="#">Boxers</a></li>
                <li><a href="#">Vests</a></li>
                <li><a href="#">Sleepwear & Loungewear</a></li>
                <li><a href="#">Thermals</a></li>
            </ul>
            <hr/>
            <ul>
                <a href="#"><h4>Plus Size</h4></a>
            </ul>
        </div>
    
        <div class="drop-content">   
            <ul>
                <li><h4>Footwear</h4></li>
                <li><a href="#">Casual Shoes</a></li>
                <li><a href="#">Sports Shoes</a></li>
                <li><a href="#">Formal Shoes</a></li>
                <li><a href="#">Sneakers</a></li>
                <li><a href="#">Sandals & Floaters</a></li>
                <li><a href="#">Flip Flops</a></li>
                <li><a href="#">Socks</a></li>
            </ul>
            <hr/>
            <ul>
            <a href="#"><h4>Personal Care & Grooming</h4></a>
        </ul>
        <ul>
            <a href="#"><h4>Sunglasses & Frames</h4></a>
        </ul>
        <ul>
            <a href="#"><h4>Watches</h4></a>
        </ul>

        </div>
        <div class="drop-content">   
            <ul>
               <li> <h4>Sports & Active Wear</h4></li>
                <li><a href="#">Sports Shoes</a></li>
                <li><a href="#">Sports Sandals</a></li>
                <li><a href="#">Active T-Shirts</a></li>
                <li><a href="#">Track Pants & Shorts</a></li>
                <li><a href="#">Tracksuits</a></li>
                <li><a href="#">Jackets & Sweatshirts</a></li>
                <li><a href="#">Sports Accessories</a></li>
                <li><a href="#">Swimwear</a></li>
            </ul>
            <hr/>
        <ul>
            <li><h4>Gadgets</h4></li>
            <li><a href="#">Smart Wearables</a></li>
            <li><a href="#">Fitness Gadgets</a></li>
            <li><a href="#">Headphones</a></li>
            <li><a href="#">Speakers</a></li>
        </ul>
        </div>
        <div class="drop-content">   
            <ul>
                <li><h4>Fashion Accessories</h4></li>
                <li><a href="#">Wallets</a></li>
                <li><a href="#">Belts</a></li>
                <li><a href="#">Perfumes & Body Mists</a></li>
                <li><a href="#">Trimmers</a></li>
                <li><a href="#">Deodorants</a></li>
                <li><a href="#">Ties, Cufflinks & Pocket Squares</a></li>
                <li><a href="#">Accessory Gift Sets</a></li>
                <li><a href="#">Caps & Hats</a></li>
                <li><a href="#">Mufflers, Scarves & Gloves</a></li>
                <li><a href="#">Phone Cases</a></li>
                <li><a href="#">Rings & Wristwear</a></li>
                <li><a href="#">Helmets</a></li>
            </ul>
            <hr/>
            <ul>
            <a href="#"><h4>Bags & Backpacks</h4></a>
        </ul>
        <hr/>
        <ul>
            <a href="#"><h4>Luggages & Trolleys</h4></a>
        </ul>
        </div>
    </div>   
            </div>
            <div className="nav_bar_items drp" >
              <a href="" style={style}>WOMEN</a>
              <div class="dropdown">
    <div class="drop-content">
        <ul>
            <li><h4>Indian & Fusion Wear</h4></li>
            <li><a href="#">Kurtas & Suits</a></li>
            <li><a href="#">Kurtis, Tunics & Tops</a></li>
            <li><a href="#">Sarees</a></li>
            <li><a href="#">Ethnic Wear</a></li>
            <li><a href="#">Leggings, Salwars & Churidars</a></li>
            <li><a href="#">Skirts & Palazzos</a></li>
            <li><a href="#">Dress Materials</a></li>
            <li><a href="#">Lehenga Cholis</a></li>
            <li><a href="#">Dupattas & Shawls</a></li>
            <li><a href="#">Jackets</a></li>
        </ul>
        <hr/>
        <ul>
            <li><a href="#"><h4>Belts, Scarves & More</h4></a></li>
            <li><a href="#"><h4>Watches & Wearables</h4></a></li>
        </ul>
    </div>

    <div class="drop-content">
        <ul>
            <li><h4>Western Wear</h4></li>
            <li><a href="#">Dresses</a></li>
            <li><a href="#">Tops</a></li>
            <li><a href="#">Tshirts</a></li>
            <li><a href="#">Jeans</a></li>
            <li><a href="#">Trousers & Capris</a></li>
            <li><a href="#">Shorts & Skirts</a></li>
            <li><a href="#">Co-ords</a></li>
            <li><a href="#">Playsuits</a></li>
            <li><a href="#">Jumpsuits</a></li>
            <li><a href="#">Shrugs</a></li>
            <li><a href="#">Sweaters & Sweatshirts</a></li>
            <li><a href="#">Jackets & Coats</a></li>
            <li><a href="#">Blazers & Waistcoats</a></li>
        </ul>
        <hr/>
        <ul>
        <li><a href="#"><h4>Plus Size</h4></a></li>
        </ul>
    </div>

    <div class="drop-content">
        <ul>
            <li><a href="#"><h4>Maternity</h4></a></li>
        </ul>
        <ul>
           <li><a href="#"><h4>Sunglasses & Frames</h4></a></li>
        </ul>
        <hr/>
        <ul>
            <li><h4>Footwear</h4></li>
            <li><a href="#">Flats</a></li>
            <li><a href="#">Casual Shoes</a></li>
            <li><a href="#">Heels</a></li>
            <li><a href="#">Boots</a></li>
            <li><a href="#">Sports Shoes & Floaters</a></li>
        </ul>
        <hr/>
        <ul>
            <li><h4>Sports & Active Wear</h4></li>
            <li><a href="#">Clothing</a></li>
            <li><a href="#">Footwear</a></li>
            <li><a href="#">Sports Accessories</a></li>
            <li><a href="#">Sports Equipment</a></li>
        </ul>
    </div>

    <div class="drop-content">
        <ul>
            <li><h4>Lingerie & Sleepwear</h4></li>
            <li><a href="#">Bra</a></li>
            <li><a href="#">Briefs</a></li>
            <li><a href="#">Shapewear</a></li>
            <li><a href="#">Sleepwear & Loungewear</a></li>
            <li><a href="#">Swimwear</a></li>
            <li><a href="#">Camisoles & Thermals</a></li>
        </ul>
        <hr/>
        <ul>
            <li><h4>Beauty & Personal Care</h4></li>
            <li><a href="#">Makeup</a></li>
            <li><a href="#">Skincare</a></li>
            <li><a href="#">Premium Beauty</a></li>
            <li><a href="#">Lipsticks</a></li>
            <li><a href="#">Fragrances</a></li>
        </ul>
    </div>

    <div class="drop-content">
        <ul>
            <li><h4>Gadgets</h4></li>
            <li><a href="#">Smart Wearables</a></li>
            <li><a href="#">Fitness Gadgets</a></li>
            <li><a href="#">Headphones</a></li>
            <li><a href="#">Speakers</a></li>
        </ul>
        <hr/>
        <ul>
            <li><h4>Jewellery</h4></li>
            <li><a href="#">Fashion Jewellery</a></li>
            <li><a href="#">Fine Jewellery</a></li>
            <li><a href="#">Earrings</a></li>
        </ul>
        <hr/>
        <ul>
            <li><a href="#"><h4>Backpacks</h4></a></li>
        </ul>
        <ul>
        <li><a href="#"><h4>Handbags, Bags & Wallets</h4></a></li>
        </ul>
        <ul>
        <li><a href="#"><h4>Luggages & Trolleys</h4></a></li>
        </ul>
    </div>
</div>
            </div>
            <div className="nav_bar_items drp" >
              <a href=""style={style}>KIDS </a>
              <div class="dropdown">
    <div class="drop-content">
        <ul>
            <li><h4>Boys Clothing</h4></li>
            <li><a href="#">T-Shirts</a></li>
            <li><a href="#">Shirts</a></li>
            <li><a href="#">Shorts</a></li>
            <li><a href="#">Jeans</a></li>
            <li><a href="#">Trousers</a></li>
            <li><a href="#">Clothing Sets</a></li>
            <li><a href="#">Ethnic Wear</a></li>
            <li><a href="#">Track Pants & Pyjamas</a></li>
            <li><a href="#">Jacket, Sweater & Sweatshirts</a></li>
            <li><a href="#">Party Wear</a></li>
            <li><a href="#">Innerwear & Thermals</a></li>
            <li><a href="#">Nightwear & Loungewear</a></li>
            <li><a href="#">Value Packs</a></li>
        </ul>
    </div>
    
    <div class="drop-content">
        <ul>
            <li><h4>Girls Clothing</h4></li>
            <li><a href="#">Dresses</a></li>
            <li><a href="#">Tops</a></li>
            <li><a href="#">Tshirts</a></li>
            <li><a href="#">Clothing Sets</a></li>
            <li><a href="#">Lehenga Choli</a></li>
            <li><a href="#">Kurta Sets</a></li>
            <li><a href="#">Party Wear</a></li>
            <li><a href="#">Dungarees & Jumpsuits</a></li>
            <li><a href="#">Skirts & Shorts</a></li>
            <li><a href="#">Tights & Leggings</a></li>
            <li><a href="#">Jeans, Trousers & Capris</a></li>
            <li><a href="#">Jacket, Sweater & Sweatshirts</a></li>
            <li><a href="#">Innerwear & Thermals</a></li>
            <li><a href="#">Nightwear & Loungewear</a></li>
            <li><a href="#">Value Packs</a></li>
        </ul>
    </div>
    
    <div class="drop-content">
        <ul>
            <li><h4>Footwear</h4></li>
            <li><a href="#">Casual Shoes</a></li>
            <li><a href="#">Flipflops</a></li>
            <li><a href="#">Sports Shoes</a></li>
            <li><a href="#">Flats</a></li>
            <li><a href="#">Sandals</a></li>
            <li><a href="#">Heels</a></li>
            <li><a href="#">School Shoes</a></li>
            <li><a href="#">Socks</a></li>
        </ul>
        <hr/>
        <ul>
            <li><h4>Toys & Games</h4></li>
            <li><a href="#">Learning & Devlopment</a></li>
            <li><a href="#">Activity Toys</a></li>
            <li><a href="#">Soft Toys</a></li>
            <li><a href="#">Action Figure/Play Set</a></li>
        </ul>
    </div>

    <div class="drop-content">
        <ul>
            <li><h4>Infants</h4></li>
            <li><a href="#">Bodysuits</a></li>
            <li><a href="#">Rompers & Sleepsuits</a></li>
            <li><a href="#">Clothing Sets</a></li>
            <li><a href="#">Tshirts & Tops</a></li>
            <li><a href="#">Dresses</a></li>
            <li><a href="#">Bottom Wear</a></li>
            <li><a href="#">Winter Wear</a></li>
            <li><a href="#">Innerwear & Sleepwear</a></li>
            <li><a href="#">Infant Care</a></li>
        </ul>
        <hr/>
        <ul>
            <li><a href=''><h4>Home & Bath</h4></a></li>
            <li><a href=''><h4>Personal care</h4></a></li>
        </ul>
    </div>

    <div class="drop-content">
        <ul>
            <li><h4>Kids Accessories</h4></li>
            <li><a href="#">Bags & Backpacks</a></li>
            <li><a href="#">Watches</a></li>
            <li><a href="#">Jewellery & Hair Accessory</a></li>
            <li><a href="#">Sunglasses</a></li>
            <li><a href="#">Masks & Protective Gears</a></li>
            <li><a href="#">Caps & Hats</a></li>
        </ul>
        <hr/>
        <ul>
            <li><h4>Brands</h4></li>
            <li><a href="#">H&M</a></li>
            <li><a href="#">Max Kids</a></li>
            <li><a href="#">Pantaloons</a></li>
            <li><a href="#">United Colors of Benetton Kids</a></li>
            <li><a href="#">YK</a></li>
            <li><a href="#">U.S. Polo Assn. Kids</a></li>
            <li><a href="#">Mothercare</a></li>
            <li><a href="#">HRX</a></li>
        </ul>
    </div>
</div>

            </div>
            <div className="nav_bar_items drp" >
              <a href=""style={style}>HOME&LIVING</a>
              <div class="dropdown">
    <div class="drop-content">
        <ul>
            <li><h4>Bed Linen & Furnishing</h4></li>
            <li><a href="#">Bed Runners</a></li>
            <li><a href="#">Mattress Protectors</a></li>
            <li><a href="#">Bedsheets</a></li>
            <li><a href="#">Bedding Sets</a></li>
            <li><a href="#">Blankets, Quilts & Dohars</a></li>
            <li><a href="#">Pillows & Pillow Covers</a></li>
            <li><a href="#">Bed Covers</a></li>
            <li><a href="#">Diwan Sets</a></li>
            <li><a href="#">Chair Pads & Covers</a></li>
            <li><a href="#">Sofa Covers</a></li>
        </ul>
    </div>
    
    <div class="drop-content">
        <ul>
            <li><h4>Flooring</h4></li>
            <li><a href="#">Floor Runners</a></li>
            <li><a href="#">Carpets</a></li>
            <li><a href="#">Floor Mats & Dhurries</a></li>
            <li><a href="#">Door Mats</a></li>
        </ul>
    </div>
    
    <div class="drop-content">
        <ul>
            <li><h4>Home Décor</h4></li>
            <li><a href="#">Plants & Planters</a></li>
            <li><a href="#">Aromas & Candles</a></li>
            <li><a href="#">Clocks</a></li>
            <li><a href="#">Mirrors</a></li>
            <li><a href="#">Wall Décor</a></li>
            <li><a href="#">Festive Decor</a></li>
            <li><a href="#">Pooja Essentials</a></li>
            <li><a href="#">Wall Shelves</a></li>
            <li><a href="#">Fountains</a></li>
            <li><a href="#">Showpieces & Vases</a></li>
            <li><a href="#">Ottoman</a></li>
        </ul>
    </div>

    <div class="drop-content">
        <ul>
            <li><h4>Kitchen & Table</h4></li>
            <li><a href="#">Table Runners</a></li>
            <li><a href="#">Dinnerware & Serveware</a></li>
            <li><a href="#">Cups and Mugs</a></li>
            <li><a href="#">Bakeware & Cookware</a></li>
            <li><a href="#">Kitchen Storage & Tools</a></li>
            <li><a href="#">Bar & Drinkware</a></li>
            <li><a href="#">Table Covers & Furnishings</a></li>
        </ul>
    </div>

    <div class="drop-content">
        <ul>
            <li><h4>Brands</h4></li>
            <li><a href="#">H&M</a></li>
            <li><a href="#">Marks & Spencer</a></li>
            <li><a href="#">Home Centre</a></li>
            <li><a href="#">Spaces</a></li>
            <li><a href="#">D'Decor</a></li>
            <li><a href="#">Story@Home</a></li>
            <li><a href="#">Pure Home & Living</a></li>
            <li><a href="#">Swayam</a></li>
            <li><a href="#">Raymond Home</a></li>
            <li><a href="#">Maspar</a></li>
        </ul>
    </div>
</div>

            
            </div>
            <div className="nav_bar_items drp" >
              <a href=""style={style}>BEAUTY</a>
              <div class="dropdown">
    <div class="drop-content">
        <ul>
            <li><h4>Makeup</h4></li>
            <li><a href="#">Lipstick</a></li>
            <li><a href="#">Lip Gloss</a></li>
            <li><a href="#">Lip Liner</a></li>
            <li><a href="#">Mascara</a></li>
            <li><a href="#">Eyeliner</a></li>
            <li><a href="#">Kajal</a></li>
            <li><a href="#">Eyeshadow</a></li>
            <li><a href="#">Foundation</a></li>
            <li><a href="#">Primer</a></li>
            <li><a href="#">Concealer</a></li>
            <li><a href="#">Compact</a></li>
            <li><a href="#">Nail Polish</a></li>
        </ul>
    </div>
    
    <div class="drop-content">
        <ul>
            <li><h4>Skincare, Bath & Body</h4></li>
            <li><a href="#">Face Moisturiser</a></li>
            <li><a href="#">Cleanser</a></li>
            <li><a href="#">Masks & Peel</a></li>
            <li><a href="#">Sunscreen</a></li>
            <li><a href="#">Serum</a></li>
            <li><a href="#">Face Wash</a></li>
            <li><a href="#">Eye Cream</a></li>
            <li><a href="#">Lip Balm</a></li>
            <li><a href="#">Body Lotion</a></li>
            <li><a href="#">Body Wash</a></li>
            <li><a href="#">Body Scrub</a></li>
            <li><a href="#">Hand Cream</a></li>
            <hr/>
            <li><h4>Baby Care</h4></li>
            <li><h4>Masks</h4></li>
        </ul>
    </div>
    
    <div class="drop-content">
        <ul>
            <li><h4>Haircare</h4></li>
            <li><a href="#">Shampoo</a></li>
            <li><a href="#">Conditioner</a></li>
            <li><a href="#">Hair Cream</a></li>
            <li><a href="#">Hair Oil</a></li>
            <li><a href="#">Hair Gel</a></li>
            <li><a href="#">Hair Color</a></li>
            <li><a href="#">Hair Serum</a></li>
            <li><a href="#">Hair Accessory</a></li>
            <hr/>
            <li><h4>Fragrances</h4></li>
            <li><a href="#">Perfume</a></li>
            <li><a href="#">Deodorant</a></li>
            <li><a href="#">Body Mist</a></li>
        </ul>
    </div>
    
    <div class="drop-content">
        <ul>
            <li><h4>Appliances</h4></li>
            <li><a href="#">Hair Straightener</a></li>
            <li><a href="#">Hair Dryer</a></li>
            <li><a href="#">Epilator</a></li>
            <hr/>
            <li><h4>Men's Grooming</h4></li>
            <li><a href="#">Trimmers</a></li>
            <li><a href="#">Beard Oil</a></li>
            <li><a href="#">Hair Wax</a></li>
            <hr/>
            <li><h4>Beauty Gift & Makeup Set</h4></li>
            <li><a href="#">Beauty Gift</a></li>
            <li><a href="#">Makeup Kit</a></li>
            <hr/>
            <li><h4>Premium Beauty</h4></li>
            <li><h4>Wellness & Hygiene</h4></li>
        </ul>
    </div>

    <div class="drop-content">
        <ul>
            <li><h4>Top Brands</h4></li>
            <li><a href="#">Lakme</a></li>
            <li><a href="#">Maybelline</a></li>
            <li><a href="#">LOreal</a></li>
            <li><a href="#">Philips</a></li>
            <li><a href="#">Bath & Body Works</a></li>
            <li><a href="#">THE BODY SHOP</a></li>
            <li><a href="#">Biotique</a></li>
            <li><a href="#">Mamaearth</a></li>
            <li><a href="#">MCaffeine</a></li>
            <li><a href="#">Nivea</a></li>
            <li><a href="#">Lotus Herbals</a></li>
            <li><a href="#">LOreal Professionnel</a></li>
            <li><a href="#">KAMA AYURVEDA</a></li>
            <li><a href="#">M.A.C</a></li>
            <li><a href="#">Forest Essentials</a></li>
        </ul>
    </div>
</div>

              </div>
            <div className="nav_bar_items drp" >
              <a href="" style={style}>STUDIO<sup style={{ color: 'red' }}>NEW</sup></a>
            </div>
            <div className="nav_bar_items">
              <form style={{border:theme=== "light"?"2px solid black":"2px solid white"}}>
                <input type="search" placeholder="Search for Products, Brands and More" size="50" />
                <button type="submit" style={{backgroundColor:"transparent" ,border:"none"}}><FontAwesomeIcon icon="fa-solid fa-magnifying-glass" color={theme==="light"?"black":"white"}/></button>
              </form>
            </div>
            <div className="nav_bar_items" ><button  onClick={()=>dispatch(changeTheme()) } style={{ padding:" 5px 10px" ,border:theme=== "light"?"2px solid black":"2px solid white",  borderRadius:"25%",backgroundColor:theme === "light" ?"white":"transparent"}}><FontAwesomeIcon icon={theme=="light"?"fa-solid fa-moon":"fa-solid fa-sun"} color={theme==="light"?"black":"white"} size="lg"  /></button></div>
            <div className="nav_bar_items drp" >
                <span style={style}><FontAwesomeIcon icon="fa-solid fa-user" /></span>
                <a href="" style={style}> PROFILE</a>
                <div className='dropdown profile'>
                    <div className='drop-content'>
                        <div className='loginSignup'>
                        <b>Welcome</b>
                        <p>To access account and manage orders</p>
                        </div>
                        <div style={{margin:"20px", marginLeft:"0px"}}>
                        <Link className='loginSignup-btn' style={{color:"red"}}>LOGIN / SIGNUP</Link>
                        </div>
                        <hr/>
                        <ul>
                            <li><a href=''>Orders</a></li>
                            <li><a href=''>Wishlist</a></li>
                            <li><a href=''>Gift Cards</a></li>
                            <li><a href=''>Contact Us</a></li>
                            <li><a href=''>Myntra Insider</a></li>
                        </ul>
                        <hr/>
                        <ul>
                            <li><a href=''>Myntra Credit</a></li>
                            <li><a href=''>Coupons</a></li>
                            <li><a href=''>Saved cards</a></li>
                            <li><a href=''>Saved VPA</a></li>
                            <li><a href=''>Saved Addressed</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="nav_bar_items"><span style={style}><FontAwesomeIcon icon="fa-solid fa-cart-shopping" /></span><a  href="" style={style}>BAG</a></div>
            <div className="nav_bar_items"><span style={style}><FontAwesomeIcon icon="fa-solid fa-heart" /></span><a href="" style={style}>WISHLIST</a></div>
          </div>
        </nav>
      </header>
      </>
  )
}

export default Navbar
